import { Col, Row } from "react-bootstrap";
import { useState, useEffect } from 'react';
import { Button, Input, Table, Form, Popconfirm, Typography, Modal, Empty } from 'antd';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux'
import {
    getObjective, setMemberFail, getMemberFail, setMemberSuccess, getMemberSuccess, getBizID, getStyle, getFile, getFileID, getServices
} from '../../../libs/todoSlice'
import LoadingComponent from "../../../lib/LoadingComponent";
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';
import fontColor from "../../../lib/fontColor";
import { getModalBeforeSuccessRedux, setModalBeforeSuccessRedux, getModalNoteRedux, setModalNoteRedux, getLoadingRedux, setLoadingRedux, getNoteTXTRedux, setNoteTXTRedux } from "../../../libs/addFailSlice";
import { resolveNoteText } from "../../../lib/errorKeyNote";
import { retryPreRegisterItems } from "../../../lib/callAgainPreRegister";
import { resolvePreRegisterConfig, buildFieldColumns, buildEmptyFormValues } from '../../../lib/preRegisterConfig';

/**
 * แสดงรายการที่ลงทะเบียนไม่สำเร็จ พร้อมแก้ไข/ลบ/สร้างใหม่อีกครั้ง
 * Generic — ใช้ config.fields จาก preRegisterConfig.jsx เพื่อ derive columns/edit form
 * ตามประเภทที่กำลังใช้งานอยู่ (thaid / thaidGeneralForm / ประเภทอื่นในอนาคต)
 */
const PreRegisterAddMemberFail = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const memberSuccess = useSelector(getMemberSuccess)
    const memberOneFail = useSelector(getMemberFail)
    const file = useSelector(getFile)
    const objective = useSelector(getObjective)
    const services = useSelector(getServices)
    const business_id = useSelector(getBizID)
    const style = useSelector(getStyle)
    const config = resolvePreRegisterConfig(objective)

    const modalbeforeSuccess = useSelector(getModalBeforeSuccessRedux)
    const setModalBeforeSuccess = (action) => dispatch(setModalBeforeSuccessRedux({ modalbeforeSuccess: action }))

    const modalNote = useSelector(getModalNoteRedux)
    const setModalNote = (action) => dispatch(setModalNoteRedux({ modalNote: action }))

    const loading = useSelector(getLoadingRedux)
    const setLoading = (action) => dispatch(setLoadingRedux({ loading: action }))

    const noteTXT = useSelector(getNoteTXTRedux)
    const setNoteTXT = (action) => dispatch(setNoteTXTRedux({ noteTXT: action }))

    const alertManagement = () => {
        const message = `ข้อมูล Pre Registration ด้วย ${config.entityLabel}`
        if (memberSuccess.length !== 0) {
            return (
                <>สร้าง {message} แล้ว {memberSuccess.length} รายการ จาก {file.length} รายการ</>
            )
        }
        return (<>ไม่มีการสร้าง {message}</>)
    }

    const handleRetry = async () => {
        setLoading(true)

        const successResults = []
        const failResults = []

        await retryPreRegisterItems({
            keys: stateBtnAgain,
            memberOneFail,
            objective,
            business_id,
            file_id: fileID,
            services,
            onItemStart: (key) => {
                setData((prevData) =>
                    prevData.map((item) => (item.key === key ? { ...item, loading: true } : item))
                )
            },
            onItemSuccess: (key, result) => {
                successResults.push(result)
            },
            onItemFail: (key, result) => {
                failResults.push(result)
            },
        })

        const successKeys = successResults.map((r) => r.request.key)
        const success_summary = [...memberSuccess, ...successResults]
        const fail_summary = memberOneFail
            .filter((member) => !successKeys.includes(member.request.key))
            .map((member) => {
                const failed = failResults.find((f) => f.request.key === member.request.key)
                return failed || member
            })

        sendExcelSummary(success_summary, fail_summary)
        dispatch(setMemberSuccess({ member_success: success_summary }))
        dispatch(setMemberFail({ member_fail: fail_summary }))
        setStateBtnAgain([])
        setLoading(false)
        setModalBeforeSuccess(true)
    }

    // function show member to fail table — ดึงทุก field ตาม schema แทน hardcode cid/id_card_type
    const [data, setData] = useState([]);
    useEffect(() => {
        

        setData(memberOneFail.map((members, index) => ({
            key: members.request.key,
            loading: false,
            index: index,
            ...Object.fromEntries(config.fields.map(f => [f.key, members.request[f.key]])),
        })))
    }, [memberOneFail, config])
    // end function show member to fail table

    const member_fail = useSelector(getMemberFail)

    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    const isEditing = (record) => record.key === editingKey;
    const edit = (record) => {
        form.setFieldsValue({ ...buildEmptyFormValues(config), ...record });
        setEditingKey(record.key);
    };
    const cancel = () => setEditingKey('');
    const save = async (key) => {
        setStateBtnAgain([])
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => key === item.key);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, { ...item, ...row });
                setData(newData);
                dispatch(setMemberFail({
                    member_fail: memberOneFail.map((member, fail_index) => ({
                        // id_card_type เป็น select type ที่ไม่ผ่าน antd form (row จะไม่มีค่านี้)
                        // จึงต้องคง id_card_type จาก item ไว้เสมอ ไม่ให้ถูก row เขียนทับด้วยค่าว่าง
                        request: fail_index === index ? { ...member.request, ...row, id_card_type: item.id_card_type } : member.request,
                        response: member.response
                    }))
                }))
                setEditingKey('');
            }
        } catch (errInfo) {
        }
    };
    const handleDelete = (key) => {
        const newData = data.filter((item) => item.key !== key);
        setData(newData);
        dispatch(setMemberFail({
            member_fail: memberOneFail.filter((member) => member.request.key !== key)
        }))
    };

    const fieldColumns = buildFieldColumns(config, { editable: true, isEditing, data, setData })

    const columns = [
        {
            title: 'ลำดับที่',
            dataIndex: 'index',
            width: 100,
            render: (__, _, index) => index + 1,
        },
        ...fieldColumns,
        {
            title: 'operation',
            dataIndex: 'operation',
            width: 220,
            fixed: 'right',
            render: (_, record, index) => {
                const editable = isEditing(record);
                return record.loading ? <LoadingComponent width={80} height={80} /> : editable ? (
                    <span>
                        <Button
                            type='primary'
                            disabled={loading}
                            onClick={() => save(record.key)}
                            style={{ marginRight: 8, background: '#53BE35' }}
                        >
                            บันทึก
                        </Button>
                        <Popconfirm title="Sure to cancel?" disabled={loading} onConfirm={cancel}>
                            ยกเลิก
                        </Popconfirm>
                    </span>
                ) : (
                    <>
                        <Typography.Link disabled={editingKey !== '' || loading} onClick={() => edit(record)}>
                            <ModeEditOutlinedIcon style={{ color: style.primary_color ?? '#053075' }} />
                        </Typography.Link> &nbsp;
                        {data.length >= 1 ? (
                            <Popconfirm title="ต้องการลบข้อมูลนี้ใช่หรือไม่?" disabled={loading} onConfirm={() => handleDelete(record.key)}>
                                <DeleteOutlinedIcon style={{ color: 'red', cursor: 'pointer' }} />
                            </Popconfirm>
                        ) : null}
                        &nbsp;
                        <Button size='large'
                            disabled={loading}
                            style={{ backgroundColor: '#F8F9FA', color: '#053075' }}
                            onClick={() => {
                                setModalNote(true)
                                setNoteTXT(resolveNoteText(memberOneFail[index]?.response?.message))
                            }}>
                            หมายเหตุ
                        </Button>
                    </>
                );
            },
        },
    ];

    // start select row
    const [stateBtnAgain, setStateBtnAgain] = useState([]);
    const rowSelection = {
        selectedRowKeys: stateBtnAgain,
        onChange: (selectedRowKeys) => setStateBtnAgain(selectedRowKeys),
        getCheckboxProps: () => ({ disabled: loading }),
    };
    // end select row

    // function add fail or success to history
    const fileID = useSelector(getFileID)
    const successList = useSelector(getMemberSuccess)
    const params = useParams()
    const failList = useSelector(getMemberFail)
    const sendExcelSummary = async (success, fail) => {
        await axios({
            method: 'PATCH',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
            data: {
                _id: fileID,
                total: `${file.length}`,
                success: `${success.length}`,
                fail: `${fail.length}`,
                successDetail: successList,
                objective: objective,
                failDetail: failList
            }
        }).then(() => {
        }, ({ response }) => {
            const { status } = response
            if (status === 401) {
                navigate(`/${params.prefix}`)
            }
        })
    }
    // end add data to history

    const customLocale = {
        emptyText: (<Empty description="ไม่มีข้อมูล" />)
    };

    return (
        <>
            <Row>
                <Col className="d-flex justify-content-end">
                    {stateBtnAgain.length !== 0 &&
                        <>
                            <Button
                                style={{
                                    borderColor: style.secondary_color ?? '#053075',
                                    color: '#000000',
                                    marginRight: '3px'
                                }}
                                onClick={() => {
                                    const prepareData = data.filter(d => !stateBtnAgain.includes(d.key))
                                    const prepareDataFail = member_fail.filter(d => !stateBtnAgain.includes(d.request.key))
                                    setData(prepareData)
                                    dispatch(setMemberFail({ member_fail: prepareDataFail }))
                                    setStateBtnAgain([])
                                }}
                            >
                                ลบ
                            </Button>
                            <Button
                                type="primary"
                                style={{
                                    background: style.secondary_color ?? '#053075',
                                    color: style.secondary_color ? fontColor(style.secondary_color) : '#FFFFFF'
                                }}
                                disabled={loading}
                                onClick={handleRetry}
                            >
                                <AutorenewIcon /> ดำเนินการสร้างอีกครั้ง
                            </Button>
                        </>
                    }
                </Col>
            </Row>
            <Row style={{ marginTop: '20px' }}>
                <Form form={form} component={false}>
                    <Table
                        locale={customLocale}
                        bordered
                        dataSource={data}
                        columns={columns}
                        rowClassName="editable-row"
                        pagination={{ onChange: cancel }}
                        scroll={{ x: 900, y: 400 }}
                        rowSelection={{ type: 'checkbox', ...rowSelection }}
                    />
                </Form>
            </Row>
            <Modal
                title="หมายเหตุ"
                centered
                open={modalNote}
                footer={null}
                onCancel={() => setModalNote(false)}
            >
                {noteTXT.map((notes, i) => (
                    notes && (
                        <span key={i}>
                            <ul>
                                <li>{JSON.stringify(notes).replaceAll('"', '')}</li>
                            </ul>
                        </span>
                    )
                ))}
            </Modal>
            <Modal
                title={memberSuccess.length !== 0 ? "ทำรายการสำเร็จ" : "ทำรายการไม่สำเร็จ"}
                centered
                open={modalbeforeSuccess}
                onOk={() => setModalBeforeSuccess(false)}
                onCancel={() => setModalBeforeSuccess(false)}
                footer={null}
            >
                <Row>
                    <Col className='d-flex justify-content-center'>
                        {memberSuccess.length !== 0 ?
                            <CheckIcon style={{ background: '#53BE35', borderRadius: '50%', fontSize: '50px', color: '#fff', padding: '10px' }} />
                            :
                            <CloseIcon style={{ background: '#F37959', borderRadius: '50%', fontSize: '50px', color: '#fff', padding: '10px' }} />
                        }
                    </Col>
                </Row>
                <Row style={{ paddingTop: '30px', paddingBottom: '30px' }}>
                    <Col className='d-flex justify-content-center'>
                        {alertManagement()}
                    </Col>
                </Row>
            </Modal>
        </>
    )
}
export default PreRegisterAddMemberFail